module.exports = {
  debugMessages: require('./src/debug-messages.json'),
  infoMessages: require('./src/info-messages.json'),
  warnMessages: require('./src/warn-messages.json'),
  errorMessages: require('./src/error-messages.json'),
  errorMessagesV2: require('./src/error-messages-v2.json'),
  traceMessages: require('./src/trace-messages.json')
}
